import { render, staticRenderFns } from "./NuevoProducto.vue?vue&type=template&id=1cb3fcac&scoped=true"
import script from "./NuevoProducto.vue?vue&type=script&lang=js"
export * from "./NuevoProducto.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "spinkit/spinkit.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./NuevoProducto.vue?vue&type=style&index=2&id=1cb3fcac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb3fcac",
  null
  
)

export default component.exports